export const findLvl = (folders, targetLvl, currentLvl = 0) => {
  let result = [];
  for (const folder of folders) {
    if (currentLvl === targetLvl) {
      result.push(folder);
    } else {
      if (folder.children) {
        result.push(...findLvl(folder.children, targetLvl, currentLvl + 1));
      }
      if (folder.templates) {
        result.push(...findLvl(folder.templates, targetLvl, currentLvl + 1));
      }
    }
  }
  return result;
};

export const findName = (foldersTree, translatedName) => {
  for (const folder of foldersTree) {
    if (
      folder.templates &&
      folder.translatedName.toLowerCase() !== translatedName.toLowerCase()
    ) {
      for (const template of folder.templates) {
        if (
          template.translatedName.toLowerCase() === translatedName.toLowerCase()
        ) {
          return { ...template };
        }
      }
    }
    if (folder.translatedName.toLowerCase() === translatedName.toLowerCase()) {
      return { ...folder };
    }
  }
  return { notFound: true };
};

export const checkURLforTree = (folders, paramsFronNext, lvl = 0) => {
  const cleanParams = paramsFronNext.filter(
    (elem) => elem !== '@' && elem !== 'service-worker.js'
  );
  let folderFirstLvl = {};
  for (const folder of folders) {
    if (lvl === 0) {
      if (folder.translatedName === paramsFronNext[lvl]) {
        folderFirstLvl = { ...folder };
      }
    }
  }
  if (cleanParams.length === 1) {
    return !Object.keys(folderFirstLvl).length
      ? { notFound: true }
      : folderFirstLvl;
  }

  lvl++;
  if (cleanParams.length > 1) {
    let resultFind = {};
    for (let i = 0; i <= cleanParams.length - 1; i++) {
      let dataThisLvlFolder = findLvl(folders, i);
      resultFind = findName(dataThisLvlFolder, cleanParams[i]);
      if (resultFind.notFound == true) return { notFound: true };
    }
    return resultFind;
  }
};

const addPathToTheTree = (elements, currentPath = '') => {
  return elements.map((element) => {
    const newPath = currentPath
      ? `${currentPath}/${element.translatedName}`
      : `${element.translatedName}`;

    const updatedElement = {
      ...element,
      path: newPath,
      templates: element.templates
        ? element.templates.map((template) => ({
            ...template,
            path: `${newPath}/${template.translatedName}`,
          }))
        : [],
      children: element.children
        ? addPathToTheTree(element.children, newPath)
        : [],
    };
    return updatedElement;
  });
};

export const createTreeFolders = (folders, templates, needPathForLink) => {
  let map = {};
  let tree = [];

  for (let i = 0; i < folders.length; i++) {
    map[folders[i].id] = { ...folders[i], children: [], templates: [] };
  }
  for (let i = 0; i < templates.length; i++) {
    if (map[templates[i].folder.id]) {
      map[templates[i].folder.id].templates.push({ ...templates[i] });
    }
  }
  for (let i = 0; i < folders.length; i++) {
    if (!folders[i].parentid) {
      tree.push(map[folders[i].id]);
    } else {
      const parentID = folders[i].parentid;
      map[parentID].children.push(map[folders[i].id]);
    }
  }
  if (needPathForLink) return addPathToTheTree(tree);
  return tree;
};

export const collectRootFolderWithAllInnerTemplates = (tree) => {
  const rootFolderWithTemplates = [];
  const collectDataFromFolder = (elementTreeFolder) => {
    let templates = [...elementTreeFolder.templates];
    1;
    if (elementTreeFolder.children && elementTreeFolder.children.length > 0) {
      for (const child of elementTreeFolder.children) {
        templates = [...templates, ...collectDataFromFolder(child)];
      }
    }
    return templates;
  };
  for (let i = 0; i < tree.length; i++) {
    rootFolderWithTemplates.push({
      ...tree[i],
      templates: collectDataFromFolder(tree[i]),
    });
  }
  return rootFolderWithTemplates;
};

export const collectAllLvlsWithPath = (
  tree,
  result = { folders: [], templates: [] }
) => {
  for (let folder of tree) {
    if (!folder.parentid) {
      result.folders.push({ ...folder });
    }
    if (folder.templates) {
      for (let template of folder.templates) {
        result.templates.push({ ...template });
      }
    }

    if (folder.children) {
      for (let folderChild of folder.children) {
        result.folders.push(folderChild);
      }
      collectAllLvlsWithPath(folder.children, result);
    }
  }
  return result;
};

export const getListTemplatesAndFoldersWithPath = (folders, templates) => {
  const tree = createTreeFolders(folders, templates, true);
  return collectAllLvlsWithPath(tree);
};
